var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportCreator42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2 8.30078C36.2 5.30078 31.3 5.30078 28.3 8.30078C27.1 9.50078 26.3 11.0008 26.1 12.7008V13.0008L34.5 21.4008H34.8C36.5 21.2008 38 20.4008 39.2 19.2008C42.3 16.2008 42.3 11.3008 39.2 8.30078ZM38.3 18.3008C37.4 19.2008 36.2 19.8008 35 20.1008L27.5 12.7008C27.7 11.4008 28.3 10.3008 29.2 9.40078C31.7 6.90078 35.7 6.90078 38.2 9.40078C40.8 11.7008 40.8 15.8008 38.3 18.3008Z",
    fill: "#4D4A45",
    stroke: "#4D4A45",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 40.6023H26V28.5023L33.1 23.4023L33.2 23.3023C33.4 23.0023 33.4 22.6023 33.2 22.4023L25.3 14.5023C25 14.2023 24.6 14.2023 24.3 14.5023C24.3 14.5023 24.3 14.6023 24.2 14.6023L9.8 34.6023C9.6 34.9023 9.6 35.2023 9.9 35.5023L10.6 36.2023L6.6 40.2023C6.3 40.5023 6.3 40.9023 6.6 41.1023C6.7 41.2023 6.9 41.3023 7.1 41.3023C7.3 41.3023 7.4 41.2023 7.6 41.1023L11.6 37.1023L12.2 37.7023C12.3 37.8023 12.5 37.9023 12.7 37.9023C12.8 37.9023 13 37.9023 13.1 37.8023L24.6 29.5023V40.6023H19.1C18.7 40.6023 18.4 40.9023 18.4 41.3023C18.4 41.7023 18.7 42.0023 19.1 42.0023H31.5C31.9 42.0023 32.2 41.7023 32.2 41.3023C32.2 40.9023 31.9 40.6023 31.5 40.6023ZM12.8 36.4023L11.3 34.9023L24.9 16.0023L31.7 22.8023L12.8 36.4023Z",
    fill: "#4D4A45",
    stroke: "#4D4A45",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportCreator42);
export default __webpack_public_path__ + "static/media/icons-2_export-CREATOR-42.a01763065e4d78f236d5510cc45d9a15.svg";
export { ForwardRef as ReactComponent };